// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emptyState--bxuHEsgY{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:60px 20px;color:rgba(0,0,0,0.45)}.emptyStateIcon--lgiof8G0{width:50px;height:50px;margin-bottom:16px;opacity:0.6}.emptyStateTitle--aIHUcnqk{font-size:14px;font-weight:500;color:rgba(0,0,0,0.65);margin-bottom:4px}.emptyStateDescription--YiVHqQCZ{font-size:12px;color:rgba(0,0,0,0.45);text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyState": `emptyState--bxuHEsgY`,
	"emptyStateIcon": `emptyStateIcon--lgiof8G0`,
	"emptyStateTitle": `emptyStateTitle--aIHUcnqk`,
	"emptyStateDescription": `emptyStateDescription--YiVHqQCZ`
};
export default ___CSS_LOADER_EXPORT___;
